// extracted by css-extract-rspack-plugin
export default {"cardWidth":"220px","sentCardBox":"sent-card__sentCardBox___dgrXb","filterRadioButtons":"sent-card__filterRadioButtons___vWAxS","sentErrorCard":"sent-card__sentErrorCard___LzMda"};